import React from "react"

import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid"

import { Color } from "~tailwindui/types/enums"

import { AutocompleteNavigate } from "~tailwindui/Form"
import { buttonColorClassNames } from "~tailwindui/helpers/classNameHelpers"

import classNames from "src/classNames"

export type QuickLinksProps = {
  ssoEmail: string
}

const QuickLinks: React.FC<QuickLinksProps> = ({ ssoEmail }) => {
  return (
    <>
      <div className="md:col-span-3">
        <h4 className="!mb-1 font-semibold uppercase text-gray-500">
          Quick Schedule
        </h4>
        <div className="flex flex-col gap-2 sm:flex-row">
          <AutocompleteNavigate
            resource="studyGroups"
            placeholder="Find a Study Group"
            navigateTo="studyGroupDetails"
            className="w-full sm:w-56 lg:w-64"
          />

          <AutocompleteNavigate
            resource="students"
            searchColumn="fullName"
            placeholder="Find a Student"
            navigateTo="studentDetails"
            className="w-full sm:w-56 lg:w-64"
          />
        </div>
      </div>
      <div className="mt-4 md:col-span-2 md:mt-0">
        <h4 className="!mb-1 font-semibold uppercase text-gray-500">
          Quick Links
        </h4>
        <div className="flex gap-2">
          <a
            href="https://sites.google.com/airtutors.org/tutorplaybook/home"
            target="_blank"
            rel="noopener noreferrer"
            className={classNames(
              "flex items-center rounded-md border border-solid border-white p-3 font-bold tracking-wider text-white",
              buttonColorClassNames(Color.Blue)
            )}
          >
            Tutor Playbook
            <ArrowTopRightOnSquareIcon className="ml-2 h-5 w-5" />
          </a>

          <form
            method="post"
            action="https://miro.com/sso/api/process-email"
            target="_blank"
          >
            <button
              type="submit"
              className={classNames(
                "flex items-center rounded-md border border-solid border-white p-3 font-bold tracking-wider text-white",
                buttonColorClassNames(Color.Green)
              )}
            >
              Whiteboard Home
              <ArrowTopRightOnSquareIcon className="ml-2 h-5 w-5" />
            </button>
            <input name="email" type="hidden" value={ssoEmail} />
          </form>
        </div>
      </div>
    </>
  )
}

export default QuickLinks
